module.exports = "<div class=\"container-gif\" id=\"partialLoader\">\r\n    <div></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/partialLoader/partial-loader.component.html
// module id = ../../../../../app/shared/components/partialLoader/partial-loader.component.html
// module chunks = main